<form [formGroup]="accountForm" (ngSubmit)="openCreateDialog()" class="flex flex-col gap-6">
  <h3 class="textPrimaryColor text-2xl font-bold" i18n="@@adminAddInstapayAccountTitle">Add InstaPay Account</h3>

  <div class="bgWhiteColor rounded-2xl p-6 shadow-md">
    <div class="grid grid-cols-2 gap-6">
      <!-- InstaPay Account Number -->
      <div class="flex flex-col gap-2" [dir]="locale.startsWith('ar') ? 'rtl' : 'ltr'">
        <label class="textTableHeaderColor text-sm font-bold" i18n="@@adminInstapayAccountNumberLabel">
          InstaPay Account Number

          <span class="textPrimaryColor">*</span>
        </label>

        <input
          type="text"
          formControlName="instapayAccountNumber"
          placeholder="Enter InstaPay account number"
          i18n-placeholder="@@adminInstapayAccountNumberPlaceholder"
          maxlength="11"
          inputmode="numeric"
          class="borderhelperColorOne bgWhiteColor focus:borderPrimaryColor placeholder-text-gray rounded-lg border px-3 py-2 text-sm transition-all outline-none"
          [class.!border-status-danger]="
            accountForm.get('instapayAccountNumber')?.invalid && accountForm.get('instapayAccountNumber')?.dirty
          " />

        @if (accountForm.get("instapayAccountNumber")?.invalid && accountForm.get("instapayAccountNumber")?.dirty) {
          <span class="textError text-[12px]">
            @if (accountForm.get("instapayAccountNumber")?.errors?.["required"]) {
              <span i18n="@@adminInstapayAccountNumberRequired">InstaPay account number is required.</span>

            } @else if (accountForm.get("instapayAccountNumber")?.errors?.["numbersOnly"]) {
              <span i18n="@@adminInstapayAccountNumberLettersNotAllowed">Letters are not allowed.</span>

            } @else if (accountForm.get("instapayAccountNumber")?.errors?.["pattern"]) {
              <span i18n="@@adminInstapayAccountNumberInvalid">Please enter a valid Egyptian mobile number.</span>
            }
          </span>
        }
      </div>
    </div>

    @if (errorCreatingAccount()) {
      <div class="border-status-danger bg-status-danger/10 mt-4 rounded-lg border p-3">
        <p class="text-status-danger text-sm">
          {{ errorCreatingAccount() }}
        </p>
      </div>
    }

    <!-- Action Buttons -->
    <div class="mt-24 flex justify-end gap-3">
      <!-- Cancel -->
      <button
        type="button"
        (click)="onCancel()"
        class="border-primary text-primary hover-bg-primary-10 h-10 w-28 rounded-[6px] border text-[13px] font-[500] hover:cursor-pointer">
        <span i18n="@@adminInstapayAccountCancelButton">Cancel</span>
      </button>

      <!-- Save -->
      <app-submit-button type="primary" [disabled]="loading()" class="h-10 w-28">
        @if (loading()) {
          <span i18n="@@adminInstapayAccountSavingButton">Saving...</span>
        } @else {
          <span i18n="@@adminInstapayAccountSaveButton">Save</span>
        }
      </app-submit-button>
    </div>
  </div>
</form>

@if (showCreateDialog) {
  <app-confirmation-dialog
    [layout]="'start'"
    [title]="locale.startsWith('ar') ? createTitleAr : createTitleEn"
    [description]="locale.startsWith('ar') ? createDescriptionAr : createDescriptionEn"
    [confirmContent]="locale.startsWith('ar') ? confirmButtonAr : confirmButtonEn"
    [cancelContent]="locale.startsWith('ar') ? cancelButtonAr : cancelButtonEn"
    [error]="errorCreatingAccount() ?? ''"
    (onSubmit)="confirmCreate()"
    (onCancel)="closeCreateDialog()"></app-confirmation-dialog>
}
